import React from 'react';
import * as Tools from '../../helpers/Tools';
import { Icon, LinkText, Tooltip, Typography } from "../ecosystem";

const FavoriteButton = ({
    addLabel = "Add to your favorite doctors",
    addOnClick,
    removeLabel = "Remove from your favorite doctors",
    isFavorited,
    removeOnClick,
    showLabel,
    tooltipId
}) => {

    const isMobileDevice = Tools.isMobile(); //Disable tooltip hover when on mobile device instead basing on width
    const buttonLabel = isFavorited ? removeLabel : addLabel;

    const button = <LinkText
        as={<button type="button"></button>}
        aria-label={buttonLabel}
        onClick={isFavorited ? removeOnClick : addOnClick}
        className="favorite-button-container__btn"
        decorator="mobile"
    >
        <span className="favorite-button-btn__icon"><Icon name={isFavorited ? "favorite-filled" : "favorite"} /></span>
        {showLabel && <Typography type="body-01">{buttonLabel}</Typography> }
    </LinkText>;

    return (<div className="favorite-button-container">
        {!showLabel && tooltipId && !isMobileDevice
            ? <Tooltip
                text={isFavorited ? "Remove" : "Favorite"}
                tooltipId={tooltipId ? tooltipId : ""}
            >
                {button}
            </Tooltip>
            : button
        }
    </div>);
}

export default FavoriteButton;
